import React from 'react';

interface PerformanceStatsProps {
  stats: {
    totalVolume: number;
    averageInboxRate: number;
    averageSpamRate: number;
    atRiskClients: number;
    totalClients: number;
  };
}

const PerformanceStats: React.FC<PerformanceStatsProps> = ({ stats }) => {
  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toLocaleString();
  };

  const getInboxRateClass = (rate: number): string => {
    if (rate >= 90) return 'stat-good';
    if (rate >= 70) return 'stat-warning';
    return 'stat-critical';
  };

  const getSpamRateClass = (rate: number): string => {
    if (rate <= 2) return 'stat-good';
    if (rate <= 5) return 'stat-warning';
    return 'stat-critical';
  };

  return (
    <div className="performance-stats">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <div className="stat-label">Total Volume</div>
            <div className="stat-value">{formatNumber(stats.totalVolume)}</div>
            <div className="stat-subtitle">emails sent</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📧</div>
          <div className="stat-content">
            <div className="stat-label">Total Clients</div>
            <div className="stat-value">{stats.totalClients}</div>
            <div className="stat-subtitle">active accounts</div>
          </div>
        </div>

        <div className={`stat-card ${getInboxRateClass(stats.averageInboxRate)}`}>
          <div className="stat-icon">📥</div>
          <div className="stat-content">
            <div className="stat-label">Avg Inbox Rate</div>
            <div className="stat-value">{stats.averageInboxRate.toFixed(1)}%</div>
            <div className="stat-subtitle">
              {stats.averageInboxRate >= 90 ? 'Excellent' : 
               stats.averageInboxRate >= 70 ? 'Good' : 'Needs Improvement'}
            </div>
          </div>
        </div>

        <div className={`stat-card ${getSpamRateClass(stats.averageSpamRate)}`}>
          <div className="stat-icon">🚫</div>
          <div className="stat-content">
            <div className="stat-label">Avg Spam Rate</div>
            <div className="stat-value">{stats.averageSpamRate.toFixed(1)}%</div>
            <div className="stat-subtitle">
              {stats.averageSpamRate <= 2 ? 'Excellent' : 
               stats.averageSpamRate <= 5 ? 'Acceptable' : 'High Risk'}
            </div>
          </div>
        </div>

        <div className={`stat-card ${stats.atRiskClients > 0 ? 'stat-warning' : 'stat-good'}`}>
          <div className="stat-icon">⚠️</div>
          <div className="stat-content">
            <div className="stat-label">At-Risk Clients</div>
            <div className="stat-value">{stats.atRiskClients}</div>
            <div className="stat-subtitle">
              {stats.atRiskClients === 0 ? 'All healthy' : 'need attention'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PerformanceStats);